import { render } from "./Info.vue?vue&type=template&id=b57c41d2&scoped=true"
const script = {}

import "./Info.vue?vue&type=style&index=0&id=b57c41d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b57c41d2"]])

export default __exports__